var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-h-screen-minus-footer pt-pagetop-auto"},[_c('div',{staticClass:"lg:pt-160 pt-80 container"},[_c('div',{staticClass:"flex justify-center"},[_c('spinner')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }